import React, { useState, useEffect } from 'react';
import { db } from '../../assets/js/firebase';
import './Orders.css';
import { useStateValue } from '../StateProvider/StateProvider';
import Order from '../Order/Order';
import { showLoader, hideLoader } from '../../assets/js/loader';

function Orders() {
  const [{ user }] = useStateValue();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    showLoader();
    if (window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
    if (user) {
      db.collection('users')
        .doc(user?.uid)
        .collection('orders')
        .orderBy('created', 'desc')
        .onSnapshot((snapshot) =>
          setOrders(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }))
          )
        );
    } else {
      setOrders([]);
    }
    setTimeout(() => {
      hideLoader();
    }, 2000);
  }, [user]);

  return (
    <div className="orders">
      {user !== null ? (
        <div>
          {orders.length > 0 ? <h1>Your Orders</h1> : null}
          <div className="orders__order">
            {orders.length > 0 ? (
              orders?.map((order, index) => <Order order={order} key={index} />)
            ) : (
              <h1>No orders</h1>
            )}
          </div>
        </div>
      ) : (
        <div>
          <h1>Sign in to view orders</h1>
        </div>
      )}
    </div>
  );
}

export default Orders;
